// Fallback local pour éviter une absence d'env en dev (CRA lit REACT_APP_* au build/start).
const CENTRIFUGO_WS_URL =
  process.env.REACT_APP_CENTRIFUGO_WS_URL ||
  'wss://centrifugo-fw.api.docker.localhost/connection/websocket'

export { CENTRIFUGO_WS_URL }
